import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import { dispatch } from '@rematch/core';
import { Header, Label, Card } from 'semantic-ui-react';
import { toastr } from 'react-redux-toastr';
import { debounce } from 'lodash';


import { CommonTableLayout } from '../../drive/Table/Table';
import LoadingComponent from '../../common/LoadingComponent';

export default class CommonTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            column: null,
            direction: null,
            _sort: props.sort ? props.sort : "createdAt",
            _page: 1,
            _order: props.sort && props.sort === "createdAt" ? -1 : 1,
            _limit: props.limit ? props.limit : 10,
            q: {},
            loading: props.loading || false,
            query: {},
            filterStateObj: {},
            filterData: props.listData,
            totalCount: props.totalCount,
            tableHeader: this.props.tableHeader ? this.props.tableHeader : [],
            actionType: '',
            filterByDate: {},
            filterByDropdown: {},
            filterByText: {},
            filterByTextObject: {},
            filterHeader: this.props.filterHeader,
            rowHighlight: ""
        }
    }

    componentWillMount() {
        let query = {
            $sort: { [this.state._sort]: this.state._order },
            $skip: this.state._limit * (this.state._page - 1),
            $limit: this.state._limit
        }

        this.setState({ query: query })
        if (this.props.addColumn) {
            this.props.addColumn(this.state.tableHeader)
        }

            this.setState({ filterData: null, totalCount: null })
            this.props.onQueryChange(query);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.sort && nextProps.sort !== this.props.sort) {
            this.setState({ _sort: nextProps.sort })
        }

        if (this.props.limit && nextProps.limit !== this.props.limit) {
            this.setState({ _limit: nextProps.limit })
        }


        if (this.props.tableHeader && !_.isEqual(this.props.tableHeader, nextProps.tableHeader)) {
            this.setState({ tableHeader: nextProps.tableHeader })
        }

        if (this.props.routeParams && !_.isEqual(this.props.routeParams, nextProps.routeParams)) {
            this.setState({ filterHeader: false })
            this.onSubmitFilter(null, 'Single Search')
            setTimeout(() => {
                this.setState({ filterHeader: true })
            }, 10);

            this.setState({
                _order: nextProps.sort && nextProps.sort === "createdAt" ? -1 : 1,
                _page: 1,
            })
        }

        if (this.props.activeIndex !== nextProps.activeIndex) {
            this.setState({ filterHeader: false })
            this.onSubmitFilter(null, 'Single Search')
            this.setState({
                filterByDropdown: {},
                filterByText: {},
                filterByDate: {},
                filterByTextObject: {},
                // filterHeader: false,
                _order: nextProps.sort && nextProps.sort === "createdAt" ? -1 : 1,
                _page: 1
            })
            setTimeout(() => {
                // this.setState({ filterHeader: true, loading:true })
                let query = {
                    $sort: { [this.state._sort]: this.state._order },
                    $skip: this.state._limit * (this.state._page - 1),
                    $limit: this.state._limit
                }

                    this.setState({ filterData: null, totalCount: null })
                    this.props.onQueryChange(query);
                this.setState({ filterHeader: true, loading:false })

            }, 500);
        }

        if (nextProps.listData !== this.props.listData) {
            this.setState({
                totalCount: nextProps.totalCount,
                filterData: nextProps.listData,
            })
            // this.setState({ loading:true })
            let query = {
                $sort: { [this.state._sort]: this.state._order },
                $skip: this.state._limit * (this.state._page - 1),
                $limit: this.state._limit
            }

            setTimeout(() => {
               
                this.setState({ loading:false })
            }, 1000);
        }
    }

    // You can change the actions view in table fro 3 dots to llist icon and vice-versa.
    changeMenuView = (e, data) => {
        this.setState({ actionType: data.text })
    }

    //************************************** */
    // Show and Hoide header Filter
    showFilterHeader = (e) => {
        //this.onSubmitFilter(null, 'Single Search')
        this.setState({ filterHeader: !this.state.filterHeader })
    }

    selectedRowHighlight = (e, data) => {
        this.setState({ rowHighlight: data })
    }
    //Sorting By ascending / descending
    handleSort = clickedColumn => {
        const { _sort, _order, _page } = this.state;
        let newOrder = _order === 1 ? -1 : 1;
        if (_sort !== clickedColumn) {
            this.setState({
                _sort: clickedColumn
            })
            newOrder = 1;
        }
        this.setState({ _order: newOrder })
        this.createQuery({
            $sort: { [clickedColumn]: newOrder },
            $skip: this.state._limit * (_page - 1),
            $limit: this.state._limit
        })
    };

    //Limit change 5/10/20/50/100
    onChangeLimit = (event, data) => {

        if (data.value !== this.state._limit) {
            if (this.props.onChangeLimit) {
                this.props.onChangeLimit(data.value)
            }
            this.setState({
                _limit: data.value
            })

            this.createQuery({
                $limit: data.value,
                $skip: 0,
                $sort: { [this.state._sort]: this.state._order }
            })
        }
    };

    //On Pagination page change
    onChangePage = (event, data) => {
        const { activePage } = data;
        if (activePage !== this.state._page) {
            this.setState({ _page: activePage })
            this.createQuery({
                $skip: this.state._limit * (activePage - 1),
                $limit: this.state._limit,
                $sort: { [this.state._sort]: this.state._order }
            })
        }
    };

    //Add/ Remove Column in Header filter by clicking + button
    addColumns = (e, index, row) => {
        this.state.tableHeader.forEach(header => {
            if (header.key === row.key) {
                header.listed = !header.listed
            }
        });
        this.props.addColumn([...this.state.tableHeader]);
        let clear = {
            filterby: null
        }
        this.onSubmitFilter(clear, 'Single Search')
    };

    // Filter the Data : 
    // This function is used to filter multiple filter like 
    // search, dropdown and date change
    // There are three state maintain in this function 
    // to filter the multi column search 
    // filterByDate, filterByText, filterByDropdown
    // We combine the search filter for two different search type 
    //1. Localfilter 
    //2. Server filter
    // Both function are written below and we set state 
    // filter object to filter
    onSubmitFilter = debounce(async (filter, type) => {
        //Set Date value in state key "filterByDate"
        if (filter && filter.filterby === 'date') {
            this.setState(prevState => {
                let filterByDate = Object.assign({}, prevState.filterByDate);
                filterByDate[filter.name] = filter.value;
                filterByDate['startDate'] = new Date(moment(filter.startDate, 'DD-MM-YYYY'));
                filterByDate['endDate'] = new Date(moment(filter.endDate, 'DD-MM-YYYY').locale("en").add(1, 'd').format("MMM DD, YYYY HH:MM"));
                return { filterByDate };
            })
        }

        //Set Text value in state key "filterByText"
        if (filter && filter.filterby === 'text' && typeof (filter.name) === "string") {
            this.setState({ filterHeader: true, loading:false })
            this.setState(prevState => {
                let filterByText = Object.assign({}, prevState.filterByText);
                filterByText[filter.name] = filter.value;
                return { filterByText };
            })
        }

        //Set Text value in state key "filterByTextObject"
        if (filter && filter.filterby === 'text' && typeof (filter.name) === "object") {
            this.setState(prevState => {
                let filterByTextObject = Object.assign({}, prevState.filterByTextObject);
                var splitArr = filter.value && filter.value.split(' ', 2);
                if (splitArr && splitArr[1]) {
                    filterByTextObject['firstName'] = splitArr[0];
                    filterByTextObject['lastName'] = splitArr[1];
                } else {
                    filterByTextObject['firstName'] = filter.value;
                    filterByTextObject['lastName'] = null;
                }
                return { filterByTextObject };
            })
        }

        //Set Dropdown value in state key "filterByDropdown"
        if (filter && filter.filterby === 'dropdown') {
            this.setState(prevState => {
                let filterByDropdown = Object.assign({}, prevState.filterByDropdown);
                filterByDropdown[filter.name] = filter.value;
                return { filterByDropdown };
            })
        }


        // We pass the "filterby" in all column function to set state,
        // This will help to clear filter in some senario
        if (filter && filter.filterby) { }
        else {
            this.setState({
                filterByDropdown: {},
                filterByText: {},
                filterByDate: {},
                filterByTextObject: {}
            })
        }

        setTimeout(() => {
            Object.keys(this.state.filterByText).forEach((key) => (this.state.filterByText[key] === null || this.state.filterByText[key] === '') && delete this.state.filterByText[key]);
            Object.keys(this.state.filterByTextObject).forEach((key) => (this.state.filterByTextObject[key] === null || this.state.filterByTextObject[key] === '') && delete this.state.filterByTextObject[key]);
            Object.keys(this.state.filterByDropdown).forEach((key) => (this.state.filterByDropdown[key] === null || this.state.filterByDropdown[key] === '') && delete this.state.filterByDropdown[key]);
            Object.keys(this.state.filterByDate)
                .forEach((key) =>
                    (isNaN(this.state.filterByDate && this.state.filterByDate.endDate && this.state.filterByDate.endDate.getTime() ||
                        this.state.filterByDate && this.state.filterByDate.startDate && this.state.filterByDate.startDate.getTime()))
                    && delete this.state.filterByDate[key]);

            if (type === "Single Search") {
                this.setState({ _page: 1 })
                this.createQuery({
                    $skip: 0,
                    $limit: this.state._limit,
                    $sort: { [this.state._sort]: this.state._order }
                })
            }

        }, 200);
    }, 700);


    // We can create the Query after submit any filter and pass to this function.
    // If the comman table has "this.props.onQueryChange" function in "<CommonTable>" component
    // it means we are trying to get data after api hitting, so we pass this query in that function 
    // to get the filtered data
    // If the "this.props.onQueryChange" function is not available in "<CommonTable>" so 
    // in state array "this.props.listdata" we collect all records and filter in javascript
    // to get desired filtered data
    createQuery(query) {
        this.setState({ query: query,loading:true })

        // setTimeout(() => {
        //     this.setState({ loading:false })
        // }, 1000);

            //Sending the query to api to filter data
            this.serverFilter(query);
        }
    serverFilter = (query) => {
        // append Date to query to filter in between two dates
        if (_.isEmpty(this.state.filterByDate)) { }
        else {
            let startDate = new Date(moment(this.state.filterByDate.startDate, 'DD-MM-YYYY'));
            let endDate = new Date(moment(this.state.filterByDate.endDate, 'DD-MM-YYYY'));
            // .locale("en").add(1, 'd').format("MMM DD, YYYY HH:MM"))

            query.createdAt = {
                $gte: startDate,
                $lt: endDate
            };
        }
        // If dropdown and text value is available so we creat blank $and to push filter keys
        if (_.isEmpty(this.state.filterByDropdown) &&
            _.isEmpty(this.state.filterByText) &&
            _.isEmpty(this.state.filterByTextObject)) { }
        else {
            query.$and = [];
        }
        // Check the dropdown items available and push in $and query
        if (_.isEmpty(this.state.filterByDropdown)) { }
        else {

            let key1 = Object.keys(this.state.filterByDropdown)[0];
            let value1 = Object.values(this.state.filterByDropdown)[0];

            if (key1) {
                query.$and.push({ [key1]: value1 })
            }

            let key2 = Object.keys(this.state.filterByDropdown)[1];
            let value2 = Object.values(this.state.filterByDropdown)[1];
            if (key2) {
                query.$and.push({ [key2]: value2 })
            }

            let key3 = Object.keys(this.state.filterByDropdown)[2];
            let value3 = Object.values(this.state.filterByDropdown)[2];
            if (key3) {
                query.$and.push({ [key3]: value3 })
            }
            
            let key4 = Object.keys(this.state.filterByDropdown)[3];
            let value4 = Object.values(this.state.filterByDropdown)[3];
            if (key4) {
                query.$and.push({
                    [key4]: value4
                })
            }

            let key5 = Object.keys(this.state.filterByDropdown)[4];
            let value5 = Object.values(this.state.filterByDropdown)[4];
            if (key5) {
                query.$and.push({
                    [key5]: value5
                })
            }

            let key6 = Object.keys(this.state.filterByDropdown)[5];
            let value6 = Object.values(this.state.filterByDropdown)[5];
            if (key6) {
                query.$and.push({
                    [key6]: value6
                })
            }
        }
        // Check the Text items available and push in $and query
        if (_.isEmpty(this.state.filterByText)) { }
        else {

            let key4 = Object.keys(this.state.filterByText)[0];
            let value4 = Object.values(this.state.filterByText)[0];
            if (key4) {
                query.$and.push({ [key4]: { $regex: value4, $options: 'i' } })
            }

            let key5 = Object.keys(this.state.filterByText)[1];
            let value5 = Object.values(this.state.filterByText)[1];
            if (key5) {
                query.$and.push({ [key5]: { $regex: value5, $options: 'i' } })
            }

            let key6 = Object.keys(this.state.filterByText)[2];
            let value6 = Object.values(this.state.filterByText)[2];
            if (key6) {
                query.$and.push({ [key6]: { $regex: value6, $options: 'i' } })
            }
        }

        if (_.isEmpty(this.state.filterByTextObject)) { }
        else {
            let key7 = Object.keys(this.state.filterByTextObject)[0];
            let value7 = Object.values(this.state.filterByTextObject)[0];
            let key8 = Object.keys(this.state.filterByTextObject)[1];
            let value8 = Object.values(this.state.filterByTextObject)[1];

            if (key7 && !key8) {
                query.$and.push({ [key7]: { $regex: value7.trim(), $options: 'i' } })
            }

            if (key8) {
                query.$and.push(
                    { [key7]: { $regex: "^" + value7 + "$".trim(), $options: 'i' } },
                    { [key8]: { $regex: value8, $options: 'i' } }
                )
            }
        }
        this.props.onQueryChange(query);

    }

    //This function is used when if you have any component in application.
    //eg : We are using check box in workplace table to make default anu workspace
    handleTableComponentForNull() {
        return;
    }

    // Here you can add all resource pane to be set null so when ever you click on header filter 
    // resource pane will be closed
    headerClickHideResourcePane() {
        //dispatch.organizationUnit.showResourecePane(null);
        dispatch.content.openResourcePane(null);
    }

    //Create Download css file 
    downloadAsCSV = async (e, data) => {
        this.setState({ downloadCSVFileFlag: true })
        if (typeof (this.props.onQueryChange) === 'function') {
            let downloadQuery = this.state.query;
            downloadQuery.$limit = 1000
            await this.props.onQueryChange(downloadQuery);
            setTimeout(() => {
                this.setState({ downloadCSVFileFlag: false })
                if (this.props.csvData && this.props.csvData.length !== 0) {
                    this.createCsvFile(this.props.csvData)
                } else {
                    toastr.success('Message', 'Something went Wrong.')
                }
            }, 1000);
        } else {
            setTimeout(() => {
                this.setState({ downloadCSVFileFlag: false })
                this.createCsvFile(this.props.listData)
            }, 1000);


        }
    }

    // Creating the excel structure and download function to download excel
    createCsvFile = (data) => {
        let csv = '';
        let items = data
        // Loop the array of objects
        for (let row = 0; row < items.length; row++) {

            let keysAmount = Object.keys(items[row]).length
            let keysCounter = 0
            // If this is the first row, generate the headings
            if (row === 0) {
                // Loop each property of the object
                for (let key in items[row]) {
                    // This is to not add a comma at the last cell
                    // The '\n' adds a new line
                    csv += key + (keysCounter + 1 < keysAmount ? ',' : '\r\n')
                    keysCounter++
                }
                keysCounter = 0;
                for (let key in items[row]) {
                    csv += `"${items[row][key]}"` + (keysCounter + 1 < keysAmount ? ',' : '\r\n')
                    keysCounter++
                }
            } else {
                for (let key in items[row]) {
                    csv += `"${items[row][key]}"` + (keysCounter + 1 < keysAmount ? ',' : '\r\n')
                    keysCounter++
                }
            }
            keysCounter = 0
        }
        // Once we are done looping, download the .csv by creating a link
        let csvFileName = this.props.downloadedFileName ? this.props.downloadedFileName : moment().unix()
        let link = document.createElement('a')
        link.id = 'download-csv'
        link.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv));
        link.setAttribute('download', csvFileName + '.csv');
        document.body.appendChild(link)
        document.querySelector('#download-csv').click()
        setTimeout(() => {
            var el = document.getElementById('download-csv');
            el.remove();
        }, 100);
    }

    resetFilter = () => {
            this.setState({
            filterByDropdown: {},
            filterByText: {},
            filterByDate: {},
            filterByTextObject: {},
            filterChanged: false,           
            filterHeader: false,            
            rowHighlight: "", 
            _page: 1
        }, () => {
            const query = {
                $skip: 0,
                $limit: this.state._limit,
                $sort: { [this.state._sort]: this.state._order }
            };
            
            this.setState({ query });
            if (this.props.onQueryChange) {
                this.props.onQueryChange(query);
            }
        });
    };

    render() {
        let updatedFilteredData = this.state.filterData
        if(this.state.filterData && this.state.filterData.length>0 && this.props.listData && this.props.listData.length>0 ){
            updatedFilteredData =this.state.filterData.map(item=>{
                this.props.listData.map(propItem=>{
                    if(propItem._id===item._id){
                        item.publishMe=propItem.publishMe;
                    }
                })
                return item
            })
        }
        let renderTable = <CommonTableLayout
            tableData={updatedFilteredData}
            loading={this.state.loading}
            totalCount={this.state.totalCount ? this.state.totalCount : 0}
            totalPages={Math.ceil(this.state.totalCount / this.state._limit)}
            currentPage={this.state._page}
            onChangePage={this.onChangePage}
            column={this.state._sort}
            direction={this.state._order === -1 ? "down" : "up"}
            handleSort={this.handleSort}
            onChangeLimit={this.onChangeLimit}
            limit={this.state._limit.toString()}
            resetPassword={this.resetPassword}
            tableHeader={this.state.tableHeader}
            handleDropDownItem={this.props.handleDropDownItem}
            addColumn={this.addColumns}
            q={this.state.q}
            onSubmitFilter={this.onSubmitFilter}
            handleTableComponent={this.props.handleTableComponent ? this.props.handleTableComponent : this.handleTableComponentForNull}
            selection={this.props.selection}
            query={this.state.query}
            headerClickHideResourcePane={this.headerClickHideResourcePane}
            downloadAsCSV={this.downloadAsCSV}
            filterByDate={this.state.filterByDate}
            filterByDropdown={this.state.filterByDropdown}
            filterByText={this.state.filterByText}
            filterByTextObject={this.state.filterByTextObject}
            changeMenuView={this.changeMenuView}
            actionType={this.state.actionType}
            csvData={this.props.csvData}
            filterHeader={this.state.filterHeader}
            showFilterHeader={this.showFilterHeader}
            rowHighlight={this.state.rowHighlight}
            selectedRowHighlight={this.selectedRowHighlight}
            defaultMarkAll={this.props.defaultMarkAll}
            resetFilter={this.resetFilter}
        />

        return (
            <Card fluid className="Comman-Table-Structure" >
                {/* Add Table name if Required  */}
                {this.props.tableName ?
                    <Card.Content className="comman-table-header" >
                        <Header as='h4' >
                            {this.props.tableName}
                            <Label size="small" >
                                {this.props.totalCountWithoutSearch}
                            </Label>
                        </Header>
                    </Card.Content> : null
                }
                {/*
                This a kept for comman table search but not not working. We will remove 
                this code in future if comman search is not required
                 {this.props.searchable ?
                    <Card.Content className="comman-table-filter">
                        <TableHeaderFilter
                            filter={this.state.q}
                            totalCount={this.state.totalCount}
                            column={this.state._sort}
                            direction={this.state._order === 1 ? "down" : "up"}
                            handleSort={this.handleSort}
                            tableHeader={this.state.tableHeader}
                            addColumn={this.addColumns}
                            q={this.state.q}
                            onSubmitFilter={this.onSubmitFilter}
                            loading={this.props.loading}
                            type="Multiple Search"
                            headerClickHideResourcePane={this.headerClickHideResourcePane}

                        />
                    </Card.Content> : null
                } */}
                {/* <LoadingComponent active={this.state.loading} message="Fetching Content" /> */}
                <Card.Content className="comman-table-box">
                    <LoadingComponent active={this.state.downloadCSVFileFlag} message="Downloading..." />
                    {renderTable}
                </Card.Content>
            </Card>
        );
    }
}